var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundFallSmallDeoflordepessegueiro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 327,
    viewBox: "0 0 1440 327",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1440 61.474V327H0V0Z",
    fill: "#FD7F6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundFallSmallDeoflordepessegueiro);
export default __webpack_public_path__ + "static/media/background_fall_small_deoflordepessegueiro.d8213b2a4a89cd196af0c026916b6121.svg";
export { ForwardRef as ReactComponent };